import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4098ac16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormFieldComboBox = _resolveComponent("FormFieldComboBox")!
  const _component_FieldCondition = _resolveComponent("FieldCondition")!
  const _component_DeleteIcon = _resolveComponent("DeleteIcon")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseTable = _resolveComponent("BaseTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BaseTable, {
        "column-defs": _ctx.columnDefs,
        "row-data": _ctx.fieldConditions,
        loading: false,
        enumerable: true
      }, {
        "cell(field)": _withCtx(({ row }) => [
          _createVNode(_component_FormFieldComboBox, {
            value: row.field,
            "onUpdate:value": ($event: any) => ((row.field) = $event),
            clearable: true,
            name: "operator",
            options: _ctx.fieldOptionList,
            class: "margin-0"
          }, null, 8, ["value", "onUpdate:value", "options"])
        ]),
        "cell(condition)": _withCtx(({ row, rowIndex }) => [
          _createVNode(_component_FieldCondition, {
            index: rowIndex,
            "field-condition": row
          }, null, 8, ["index", "field-condition"])
        ]),
        "cell(actions)": _withCtx(({ rowIndex }) => [
          _createElementVNode("div", null, [
            _createVNode(_component_BaseButton, {
              variant: "icon",
              title: "Delete",
              onClick: ($event: any) => (_ctx.removeField(rowIndex))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DeleteIcon)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["column-defs", "row-data"]),
      _createElementVNode("div", null, [
        _createVNode(_component_BaseButton, {
          variant: "outline-primary",
          title: "Add option",
          onClick: _ctx.addElement
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Добавить поле ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}